// PageVariablesApolices.js

export const pageVariables = {

    listaDeAgendamentoPage: process.env.VUE_APP_API_URL+"lista-atendimento-whats",
    listaDeAgendamentoPageConmFiltro: process.env.VUE_APP_API_URL+"agendamentos/lista-whatsApp/",
    pageListas: process.env.VUE_APP_API_URL+"listas",
    pageBadge: process.env.VUE_APP_API_URL+"badge",
    consultoresPage: process.env.VUE_APP_API_URL+"get-group-members/consultores",
};


